



















import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import ScaleView from 'components/ScaleView.vue'

@Component({
  components: {
    ScaleView
  }
})
export default class ItemTopicViewerSlidesViewerSlide extends Vue {

  @Prop({ default: false })
  readonly keynote!: boolean
}
